import React from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";
import { LOCKED_STATES } from "../constants";

const t = buildScopeTranslate("views.content.assessment_framework.assessments");

const LOCKED_STATE_VALUES = Object.values(LOCKED_STATES);

const AssessmentLocked = ({ lockedKey }) => (
  <div className="th-agentforce-assessment__locked-state">
    <tds-badge>
      <span>{t(`pages.intro.locked.${lockedKey}.badge`)}</span>
    </tds-badge>
    <h2 className="th-agentforce-assessment__locked-state-title">
      {t(`pages.intro.locked.${lockedKey}.title`)}
    </h2>
    <p className="th-agentforce-assessment__locked-state-body">
      {t(`pages.intro.locked.${lockedKey}.body`)}
    </p>
  </div>
);

AssessmentLocked.propTypes = {
  lockedKey: PropTypes.oneOf(LOCKED_STATE_VALUES).isRequired,
};

export default AssessmentLocked;
